const _excluded = ["children", "className", "header", "footer", "onCloseButtonClick", "hasTopbar"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Drawer as MuiDrawer, makeStyles } from '@material-ui/core';
import styles from "./Drawer.module.scss";
import { CloseButton } from "../CloseButton";
import cn from 'classnames';
const useStyles = makeStyles({
  root: {
    '& .MuiDrawer-paper': {
      height: 'calc(100% - 50px)',
      //because of top bar
      top: '50px' // because of top bar

    }
  }
});
export function Drawer(props) {
  const {
    children,
    className,
    header,
    footer,
    onCloseButtonClick,
    hasTopbar
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const classes = useStyles();
  const testId = props['data-testid'];
  return /*#__PURE__*/React.createElement(MuiDrawer, _extends({}, rest, {
    anchor: "right",
    className: cn({
      [classes.root]: hasTopbar
    }, className)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.headerContent
  }, header), onCloseButtonClick && /*#__PURE__*/React.createElement(CloseButton, {
    "data-testid": testId && "".concat(testId, "-close-button"),
    size: "small",
    onClick: onCloseButtonClick
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, children), footer && /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, footer)));
}